/**
 * Copying a link to the clipboard.
 *
 * `navigator.clipboard` needs a secure context and a user gesture, and Safari
 * on iOS is the fussiest about both. The textarea fallback is ugly and still
 * the thing that works when the modern call refuses.
 */

export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // Fall through: a refusal here is normal, not exceptional.
  }

  try {
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    // Off screen, but not display:none, which would make it unselectable.
    area.style.position = 'fixed';
    area.style.top = '-1000px';
    document.body.appendChild(area);
    area.select();
    const ok = document.execCommand('copy');
    area.remove();
    return ok;
  } catch {
    return false;
  }
}
